import dynamic from 'next/dynamic';

import { ProductCarouselBlockProps } from 'src/components/blocks/ProductCarouselBlock';
import { fetchProducts } from 'src/services/catalog';
import { ContentBlockRenderer } from 'src/types/Block';
import { AsyncTransformer } from 'src/types/Transformer';
import { lazyLoadImages } from 'src/utils/images';
import { ProductCarouselContentSection } from './types';
import { getProductsValidationErrors } from './validation';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<ProductCarouselBlockProps> =
  dynamic<ProductCarouselBlockProps>(() =>
    import('src/components/blocks/ProductCarouselBlock').then((mod) => mod.ProductCarouselBlock),
  );

const getProductCodes = (products: { product_code: string }[]) =>
  products.map(({ product_code }) => Number(product_code));

export const transformer: AsyncTransformer<
  ProductCarouselContentSection,
  ProductCarouselBlockProps
> = async (
  { _metadata, heading, products, tracking_title },
  { pageConfig, pageMetadata, positionMetadata },
) => {
  const catalogServiceProducts = await fetchProducts(getProductCodes(products));
  /* istanbul ignore next */
  const renderableProducts = (catalogServiceProducts || []).filter(
    (product) => product.purchasable,
  );
  const errors = getProductsValidationErrors(
    getProductCodes(products),
    catalogServiceProducts,
    renderableProducts,
  );

  return {
    uid: _metadata.uid,
    props: {
      title: heading,
      products: renderableProducts,
      currency: pageMetadata.currency,
      pageType: pageConfig.pageType,
      trackingTitle: tracking_title,
      lazyImages: lazyLoadImages(positionMetadata.position),
    },
    errors,
  };
};
